import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
  faCommentDots,
  faEnvelope,
  faPhone
} from '@fortawesome/free-solid-svg-icons'
import LoadingSpinner, {LoadingSpinnerSize} from '../common/LoadingSpinner'
import {useGetPropertyQuery} from '../../services/guestPortalApi'

const PropertyContactCard = ({propertyId}: {propertyId: string}) => {
  const propertyQuery = useGetPropertyQuery({propertyId})

  return (
    <ul className="space-y-3 pl-4 pt-3 font-light">
      {propertyQuery.isLoading && (
        <LoadingSpinner size={LoadingSpinnerSize.Small} />
      )}

      {propertyQuery.isError && (
        <p className="text-red-500">
          Error loading property information. Please try again later.
        </p>
      )}

      {propertyQuery.data && (
        <>
          <li>
            <p>
              <span className="pr-2">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="text-xs text-cabana"
                />
              </span>
              Call us at{' '}
              <a
                href={`tel:${propertyQuery.data?.phone}`}
                target="_blank"
                className="text-cabana md:text-black underline"
              >
                {propertyQuery.data?.phone}
              </a>
            </p>
          </li>
          <li>
            <span className="pr-2">
              <FontAwesomeIcon
                icon={faCommentDots}
                className="text-xs text-cabana"
              />
            </span>
            Text us at{' '}
            <a
              href={`tel:${propertyQuery.data?.phone}`}
              target="_blank"
              className="text-cabana md:text-black underline"
            >
              {propertyQuery.data?.phone}
            </a>
          </li>
          <li>
            <span className="pr-2">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-xs text-cabana"
              />
            </span>
            Email us at{' '}
            <a
              href={'mailto:hello@placemakr.com'}
              target="_blank"
              className="text-cabana md:text-black underline"
            >
              hello@placemakr.com
            </a>
          </li>
        </>
      )}
    </ul>
  )
}

export default PropertyContactCard
